import {makeBrowserOfflineTransport} from "@sentry/react";

type OfflineOptions = Parameters<ReturnType<typeof makeBrowserOfflineTransport>>[0];
type Envelope = Parameters<NonNullable<OfflineOptions["shouldStore"]>>[0];

export function shouldStoreErrorEnvelope(envelope: Envelope): boolean {
  const item = envelope[1][0];
  if (envelope[1].length !== 1 || !item || item[0].type !== "event") {
    return false;
  }
  const payload = item[1];
  if (!payload || typeof payload !== "object" || payload instanceof Uint8Array) {
    return false;
  }
  if ("type" in payload && payload.type !== undefined) {
    return false;
  }
  try {
    return new TextEncoder().encode(JSON.stringify(envelope)).byteLength <= 64 * 1024;
  } catch {
    return false;
  }
}

export const browserOfflineTransport: ReturnType<typeof makeBrowserOfflineTransport> =
  makeBrowserOfflineTransport();
export const browserOfflineOptions = {
  dbName: "mytour-sentry-errors-v1",
  storeName: "errors",
  maxQueueSize: 30,
  flushAtStartup: true,
  shouldStore: shouldStoreErrorEnvelope,
};
